var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-outline--info mt-2",on:{"click":function($event){$event.preventDefault();return _vm.showEdit.apply(null, arguments)}}},[_vm._v("Edit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }